var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6602 16.6416H23.0739V19.2019C23.0739 19.673 22.6915 20.0553 22.2204 20.0553H20.5136C20.0425 20.0553 19.6602 19.673 19.6602 19.2019V16.6416Z",
    stroke: "#9A9595",
    strokeWidth: 1.69901
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.884766 16.6416H4.29847V19.2019C4.29847 19.673 3.91613 20.0553 3.44504 20.0553H1.73819C1.2671 20.0553 0.884766 19.673 0.884766 19.2019V16.6416Z",
    stroke: "#9A9595",
    strokeWidth: 1.69901
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.29847 8.10742H19.6601C21.5454 8.10742 23.0738 9.63591 23.0738 11.5211V15.7883C23.0738 16.2593 22.6915 16.6417 22.2204 16.6417H1.73819C1.2671 16.6417 0.884766 16.2593 0.884766 15.7883V11.5211C0.884766 9.63591 2.41325 8.10742 4.29847 8.10742Z",
    stroke: "#9A9595",
    strokeWidth: 1.69901
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.662 11.5215C20.1331 11.5215 20.5154 11.9038 20.5154 12.3749C20.5154 12.846 20.1331 13.2283 19.662 13.2283C19.1909 13.2283 18.8086 12.846 18.8086 12.3749C18.8086 11.9038 19.1909 11.5215 19.662 11.5215Z",
    fill: "#8C8686"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.29874 11.5215C4.76983 11.5215 5.15216 11.9038 5.15216 12.3749C5.15216 12.846 4.76983 13.2283 4.29874 13.2283C3.82765 13.2283 3.44531 12.846 3.44531 12.3749C3.44531 11.9038 3.82765 11.5215 4.29874 11.5215Z",
    fill: "#8C8686"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.7435 1.28027H18.2155C18.5713 1.28027 18.8897 1.50131 19.0143 1.83415L21.3672 8.10768H2.5918L4.94469 1.83415C5.06929 1.50131 5.38762 1.28027 5.7435 1.28027Z",
    stroke: "#9A9595",
    strokeWidth: 1.69901
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0.03125 5.54785H2.59153V7.2547H0.03125V5.54785Z",
    fill: "#8C8686"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3691 5.54785H23.9294V7.2547H21.3691V5.54785Z",
    fill: "#8C8686"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.85938 12.374H17.1005",
    stroke: "#9A9595",
    strokeWidth: 1.69901
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarIcon);
export default __webpack_public_path__ + "static/media/Car_icon.7b1ab504f5cd3fec9791e8de967517dd.svg";
export { ForwardRef as ReactComponent };